import { BellOutlined } from '@ant-design/icons';
import { history, useIntl } from '@umijs/max';
import { Badge, Button, Tooltip } from 'antd';
import React from 'react';
import './style.less';

/** 运营通知（消息列表） */
export const HEADER_MESSAGE_PATH = '/member/operating/notice';

export type HeaderNoticeEntryProps = {
  /** 未读数量；不传或 0 则不显示角标 */
  unreadCount?: number;
};

const HeaderNoticeEntry: React.FC<HeaderNoticeEntryProps> = ({
  unreadCount = 0,
}) => {
  const intl = useIntl();

  const label = intl.formatMessage({
    id: 'component.headerNoticeEntry.tooltip',
    defaultMessage: '消息通知',
  });

  const btn = (
    <Button
      type="text"
      size="small"
      className="header-notice-entry__btn"
      icon={<BellOutlined className="header-notice-entry__icon" />}
      onClick={() => history.push(HEADER_MESSAGE_PATH)}
    />
  );

  return (
    <Tooltip title={label}>
      {unreadCount > 0 ? (
        <Badge count={unreadCount} size="small" offset={[-2, 2]}>
          {btn}
        </Badge>
      ) : (
        btn
      )}
    </Tooltip>
  );
};

export default HeaderNoticeEntry;
